export const LIMITS = { email: 254, name: 100, password: 256 };

const CONTROL = /[\u0000-\u001F\u007F]/g;

export function sanitizeText(v, max = 200) {
  return String(v ?? "")
    .replace(CONTROL, "")
    .replace(/[<>]/g, "")
    .trim()
    .slice(0, max);
}

export function sanitizeEmail(v) {
  return String(v ?? "")
    .replace(CONTROL, "")
    .replace(/\s+/g, "")
    .toLowerCase()
    .slice(0, LIMITS.email);
}

export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
